import { TableData } from '@anytag/shared-types';
import { InstagramUserHashtagListPostsItemPayload } from '@anytag/graphql';
import { InstagramHashtagPostDetailsModal } from '@anytag/shared-molecules';
import { TagsTable } from '../../shared';
import { ProfilePostsCount } from '../../../ProfilePostsList';
import { useInstagramHashtagsAnalyticsPostsListTable } from './hooks';

export type InstagramHashtagsAnalyticsPostsListProps = TableData<InstagramUserHashtagListPostsItemPayload>;

export const InstagramHashtagsAnalyticsPostsList = ({
  loading,
  data = [],
  totalRecords
}: InstagramHashtagsAnalyticsPostsListProps) => {
  const { columns } = useInstagramHashtagsAnalyticsPostsListTable({ data });

  return (
    <>
      <ProfilePostsCount count={totalRecords} className="shadow-none" />
      <TagsTable loading={loading} hasBorder={!!totalRecords} data={data} columns={columns} />
      <InstagramHashtagPostDetailsModal posts={data.map(({ postId }) => ({ id: postId }))} />
    </>
  );
};
